import React, { useEffect } from 'react'
import { AccordionContainer } from '../accordion/accordion.module';
import { InputContainer } from '../form/form.module';
import storePersist from '../../../redux/storePersist';
import { useAppDispatch } from '../../../hooks/hooks';
import { selectStoresListItems } from '../../../redux/stores/selector';
import { selectWarehousesListItems } from '../../../redux/ware-houses/selector';
import { useSelector } from 'react-redux';
import { stores } from '../../../redux/stores/action';
import { warehouses } from '../../../redux/ware-houses/action';
import { channel } from '../../../redux/channel/action';
import { selectChannelListItems } from '../../../redux/channel/selector';

export default function ExcludeComponent({ isSaleChannel, isCustomerTag, isCustomer, isStore, isWarehouse, isState, isCountry, isProduct, isCategory, products, handleInnerFormChange, categories, selectedExclude, customers, allTags }: any) {
  const dispatch = useAppDispatch()
  const countries = storePersist.get('countries').current?.items
  const states = storePersist.get('states').current?.items
  const channelItems = useSelector(selectChannelListItems)
  const storeLists = useSelector(selectStoresListItems)
  const warehouseListss = useSelector(selectWarehousesListItems)
  useEffect(() => {
    dispatch(stores.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/stores/list`, entity: 'stores', jsonData: {

      }
    })).then(() => {
      dispatch(warehouses.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/ware-houses/list`, entity: 'stores', jsonData: {

        }
      })).then(() => {
        dispatch(channel.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/organization-management/channels/list`, entity: 'channels', jsonData: {} }))
      })
    })
  }, [])

  return (
    <>

      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            {isCountry ?
              <div>
                <InputContainer
                  label="Countries"
                  labelField="Name"
                  list={countries}
                  onValueChange={(newValue: any) => {
                    const countryData: any = newValue.map((option: any) => option?.value || '')

                    handleInnerFormChange({
                      value: countryData,
                      field: 'Exclusions.CountryIds',
                      data: selectedExclude?.Exclusions
                    });
                  }}
                  type="multiselect"
                  valueField="Id"
                  value={selectedExclude?.Exclusions?.CountryIds}
                />

              </div>
              : null}
            {isState ?
              <div>
                <InputContainer
                  label="States"
                  labelField="Name"
                  list={states}
                  onValueChange={(newValue: any) => {
                    const stateData: any = newValue.map((option: any) => option?.value || '')

                    handleInnerFormChange({
                      value: stateData,
                      field: 'Exclusions.StateIds',
                      data: selectedExclude?.Exclusions
                    });
                  }}
                  type="multiselect"
                  valueField="Id"
                  value={selectedExclude?.Exclusions?.StateIds}
                />

              </div>
              : null}
            {isWarehouse ?
              <div>
                <InputContainer
                  label="Warehouse Name"
                  labelField="WarehouseInfo.WarehouseName"
                  list={warehouseListss?.result?.items}
                  onValueChange={(newValue: any | null) => {
                    const warehouseData: any = newValue.map((option: any) => option?.value || '')

                    handleInnerFormChange({
                      value: warehouseData,
                      field: 'Exclusions.WarehouseIds',
                      data: selectedExclude?.Exclusions
                    });
                  }}
                  type="multiselect"
                  valueField="WarehouseInfo.Id"
                  value={selectedExclude?.Exclusions?.WarehouseIds}
                />

              </div>
              : null}
            {isStore ?
              <div> <InputContainer
                label="Store Name"
                labelField="StoreName"
                list={storeLists?.result?.items}
                onValueChange={(newValue: any | null) => {
                  const storeData: any = newValue.map((option: any) => option?.value || '')

                  handleInnerFormChange({
                    value: storeData,
                    field: 'Exclusions.StoreIds',
                    data: selectedExclude?.Exclusions
                  });
                }}
                type="multiselect"
                valueField="Id"
                value={selectedExclude?.Exclusions?.StoreIds}
              />
              </div>
              : null}
            {isCustomer ?
              <div>
                <InputContainer
                  label="Customer Name"
                  labelField="AccountName"
                  list={customers}
                  onValueChange={(newValue: any | null) => {
                    const customerData: any = newValue.map((option: any) => option?.value || '')

                    handleInnerFormChange({
                      value: customerData,
                      field: 'Exclusions.CustomerIds',
                      data: selectedExclude?.Exclusions
                    });
                  }}
                  type="multiselect"
                  valueField="Id"
                  value={selectedExclude?.Exclusions?.CustomerIds}

                />
              </div>
              : null}
            {isCustomerTag ?
              <div>
                <InputContainer
                  label="Customer Tag"
                  labelField="displayText"
                  list={allTags}
                  onValueChange={(newValue: any | null) => {
                    const customerTagData: any = newValue.map((option: any) => option?.value || '')

                    handleInnerFormChange({
                      value: customerTagData,
                      field: 'Exclusions.CustomerTagIds',
                      data: selectedExclude?.Exclusions
                    });
                  }}
                  type="multiselect"
                  valueField="ValueId"
                  value={selectedExclude?.Exclusions?.CustomerTagIds}
                />
              </div>
              : null}
            {isSaleChannel ?
              <div>
                <InputContainer
                  label="Sales Channel"
                  labelField="SalesChannelName"
                  list={channelItems?.result?.items}
                  onValueChange={(newValue: any | null) => {
                    const channelData: any = newValue.map((option: any) => option?.value || '')

                    handleInnerFormChange({
                      value: channelData,
                      field: 'Exclusions.SalesChannelIds',
                      data: selectedExclude?.Exclusions
                    });
                  }}
                  type="multiselect"
                  valueField="Id"
                  value={selectedExclude?.Exclusions?.SalesChannelIds}
                />

              </div>
              : null}
            {isCategory ?
              <div>
                <InputContainer
                  label="Categorys"
                  labelField="CategoryName"
                  list={categories}
                  onValueChange={(newValue: any) => {
                    const channelData: any = newValue.map((option: any) => option?.value)

                    handleInnerFormChange({
                      value: channelData,
                      field: 'Exclusions.CategoryIds',
                      data: selectedExclude?.Exclusions
                    });
                  }}
                  type="multiselect"
                  valueField="Id"
                  value={selectedExclude?.Exclusions?.CategoryIds}
                />

              </div>
              : null}
            {isProduct ?
              <div>
                <InputContainer
                  label="Products"
                  labelField="Name"
                  list={products}
                  onValueChange={(newValue: any) => {
                    const channelData: any = newValue.map((option: any) => option?.value)

                    handleInnerFormChange({
                      value: channelData,
                      field: 'Exclusions.ProductIds',
                      data: selectedExclude?.Exclusions
                    });
                  }}
                  type="multiselect"
                  valueField="Id"
                  value={selectedExclude?.Exclusions?.ProductIds}
                />

              </div>
              : null}
          </div>}
        expandedPanel="exclusionsInfo"
        headerTitle="Exclusions Information" />
    </>
  )
}